export const globalConfig = {
  apiBaseURL: 'https://origo.gazelleplatform.com/services/',
  apiMainBaseURL: 'https://origo.gazelleplatform.com/services/security',
  apiDatahubBaseURL:
    'https://origo.gazelleplatform.com/services/security/api-proxy-service',
  apiDiagnosticBaseURL:
    'https://origo.gazelleplatform.com/services/diagnostics',
  apiServicesUrl: 'https://origo.gazelleplatform.com/services/api/',
  securityServicesUrl:
    'https://origo.gazelleplatform.com/services/security/',
  sharedServicesUrl:
    'https://origo.gazelleplatform.com/services/security/',
  apiPublicURL: 'https://api.gazelleplatform.com',
  loginUrl: 'https://app.gazelleplatform.com',
  datahubHost: 'datahub.gazelleplatform.com',
  logoutUrl:
    'https://gazelleplatform.auth0.com/v2/logout?client_id=8C3X7MNV0ftfHMhqHpvTFwzfV2TjE3lt&returnTo=https://app.gazelleplatform.com',
  authUri:
    'https://gazelleplatform.auth0.com/authorize?response_type=code&client_id=8C3X7MNV0ftfHMhqHpvTFwzfV2TjE3lt&redirect_uri=https://origo.gazelleplatform.com/callback&scope=openid%20profile%20email&state=S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  targetUrl: 'https://app.gazelleplatform.com/',
  neoUrl: "https://neo-origo.netlify.app",
  dynamoUrl: "https://dynamo-origo.netlify.app",
  breezeUrl: "https://breeze-origo.netlify.app",
  eqiusUrl: "http://localhost:3004",
  wavesUrl: "http://localhost:3005",
  state:
    'S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  platformWelcomeMessage: 'Welcome to the digital convergence experience',
  ehxClaimsTopicName: 'gazelle.ehx.claims.queue',
  ehxClaimsServer: 'amqp://192.168.192.6',
  bearerTokenValue:
    'B234A23N4S235A52SD35B34S6Z5K7L56FA87D69L79FK879A6S57F436K2JB42K34JS234FB2S3A423H4JF34B6K45A6S45F7B5K67A5S8J8D68F5H65S76A58F',
  userInfoUrl: 'https://gazelleplatform.auth0.com/userinfo',
  developmentUrl: 'http://localhost:3010',
  paginationLimit: 5,
  googleMapsApi: 'AIzaSyCeNLUmMgY8Nw1aYy9jjyswHwrcK5p_dOg',
  auth0: {
    domain: 'gazelleplatform.auth0.com',
    clientId: '8C3X7MNV0ftfHMhqHpvTFwzfV2TjE3lt',
    managementAPIUrl: 'https://gazelleplatform.auth0.com/api/v2/'
  },
  OPENTOK_URL: 'https://tokbox.com/embed/embed/ot-embed.js?',
  MAP_BOX_ACCESS_TOKEN:
    'pk.eyJ1Ijoib3JpZ29zb2Z0d2FyZSIsImEiOiJja2lkZXAyOTUwa2hpMnhwZXphcDEwYnBlIn0.bL_Xsmn35OU6bbpI9o84vQ',
  defaultFacilityId: 3597,
  defaultProviderId: 1,
  dataPerPage: 5,
  twilio: {
	messagingServiceSid : "MGa997dea2e37e42575b9424ac1703b24a",
    contentSid : "HX73fe9a3f5c5e3d820fff0f1a82d4b3de",
    whatsAppChannelNumber : "+18453799458",
	},  
  hardcoded_header: {
    headers: {
      Authorization: `Bearer e98b12d0a4d43677aef882026528e1d8:227`,
    },
  },	
	apiMainUrl: "https://origo.gazelleplatform.com/services/security",
  	apiDatahubUrl: "https://origo.gazelleplatform.com/services/security/api-proxy-service",
  	systemCodesUrl:"https://origo.gazelleplatform.com/services/security/code-catalog-data-service/get-system-code-values",
  serviceAccessToken: "fbc693b3-ba2d-41c1-b054-dd8506c5161c:100023",
  cloudName: 'Gazelle Platform'
}
 